import React from "react";
import { motion } from "framer-motion";
import "react-tippy/dist/tippy.css";
import { FaJava, FaReact, FaNode } from "react-icons/fa";
import { DiMysql } from "react-icons/di";
import { TbCodeDots } from "react-icons/tb";
import images from "../../data/images";
import {
  SiJavascript,
  SiMongodb,
  SiPython,
  SiGit,
  SiExpress,
  SiTailwindcss,
  SiPrisma,
  SiTypescript,
  SiZod,
} from "react-icons/si";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./Skills.scss";

const coloredLogos = true;

const SkillItem = ({ icon: Icon, skillName, coloredIcon }) => (
  <div className="app__skills-item flex flex-center">
    <div className="flex flex-center bg-neutral-200">
      {coloredLogos && coloredIcon ? (
        <img src={coloredIcon} alt={skillName} className="skill-logo" />
      ) : (
        <Icon />
      )}
    </div>
    <p className="content color-primary-text">{skillName}</p>
  </div>
);

const Skills = () => {
  const skills = [
    { icon: FaReact, name: "React", colored: images.reactLogo },
    { icon: SiTypescript, name: "TypeScript", colored: images.typescriptLogo },
    { icon: FaNode, name: "Node", colored: images.nodejsLogo },
    { icon: SiTailwindcss, name: "Tailwind", colored: images.tailwindLogo },
    { icon: SiMongodb, name: "MongoDB", colored: images.mongoLogo },
    { icon: SiExpress, name: "Express", colored: images.expressLogo },
    { icon: SiZod, name: "Zod", colored: images.zodLogo },
    { icon: SiJavascript, name: "JavaScript", colored: images.javascriptLogo },
    { icon: SiPrisma, name: "Prisma", colored: images.prismaLogo },
    { icon: TbCodeDots, name: "Clean Code", colored: null },
    { icon: FaJava, name: "Java", colored: images.javaLogo },
    { icon: DiMysql, name: "MySQL", colored: images.mysqlLogo },
    { icon: SiPython, name: "Python", colored: images.pythonLogo },
    { icon: SiGit, name: "Git", colored: images.gitLogo },
  ];

  return (
    <>
      <h2 className="heading-1 color-primary-text">
        What I Bring to the <span className="color-primary">Table</span>
      </h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, index) => (
            <SkillItem
              key={index}
              icon={skill.icon}
              skillName={skill.name}
              coloredIcon={skill.colored}
            />
          ))}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "flex full-width flex-col"),
  "skills",
  "bg-color-primary-bg"
);